/**
 * Wait for idle-deferred GSAP + ScrollTrigger (see snippets/zeus-gsap.liquid).
 * Uses the ready event without polling the main thread.
 */
(function () {
  var GSAP_WAIT_TIMEOUT_MS = 6000;
  var refreshScheduled = false;

  function isReady() {
    return !!(window.gsap && window.ScrollTrigger);
  }

  window.zeusWhenGsapReady = function (callback, onGiveUp) {
    if (typeof callback !== "function") return;
    if (isReady()) {
      callback();
      return;
    }

    var done = false;
    var timeoutId;

    function finish() {
      if (done || !isReady()) return;
      done = true;
      window.removeEventListener("zeus:gsap-ready", finish);
      window.clearTimeout(timeoutId);
      callback();
    }

    function giveUp() {
      if (done) return;
      done = true;
      window.removeEventListener("zeus:gsap-ready", finish);
      if (typeof onGiveUp === "function") onGiveUp();
    }

    window.addEventListener("zeus:gsap-ready", finish);
    timeoutId = window.setTimeout(giveUp, GSAP_WAIT_TIMEOUT_MS);
  };

  /**
   * Initialize below-fold work shortly before its section reaches the viewport.
   * The generous margin keeps motion ready without front-loading layout work.
   */
  window.zeusWhenNearViewport = function (target, callback, options) {
    if (!target || typeof callback !== "function") return function () {};

    if (typeof window.IntersectionObserver === "undefined") {
      callback();
      return function () {};
    }

    var observer = new window.IntersectionObserver(
      function (entries) {
        if (
          !entries.some(function (entry) {
            return entry.isIntersecting;
          })
        ) {
          return;
        }
        observer.disconnect();
        callback();
      },
      {
        root: null,
        rootMargin: (options && options.rootMargin) || "100% 0px",
        threshold: 0,
      },
    );

    observer.observe(target);
    return function () {
      observer.disconnect();
    };
  };

  /**
   * Coalesce concurrent refresh requests into one post-paint batch.
   * Later DOM mutations may schedule another batch.
   */
  window.zeusScrollTriggerRefresh = function () {
    if (!window.ScrollTrigger) return;
    if (refreshScheduled) return;
    refreshScheduled = true;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        refreshScheduled = false;
        if (!window.ScrollTrigger) return;
        window.ScrollTrigger.refresh();
      });
    });
  };
})();
